const defaultApiUrl = 'https://update.iconmarketing.shop';

// In local development, route API calls through CRA proxy to avoid
// cross-origin preflight failures against production domains.
const inferredApiUrl = process.env.REACT_APP_API_URL
  || (window.location.hostname === 'localhost' ? '/' : defaultApiUrl);

const configuredApiUrl = inferredApiUrl.trim();

// Keep request construction consistent whether the configured URL has a
// trailing slash or uses the current origin via "/".
export const api = configuredApiUrl === '/'
  ? ''
  : configuredApiUrl.replace(/\/+$/, '');
